import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetMeResponse } from './get-me-response';
import { getMeResponseSchema } from './get-me-response';

export async function getMeApi(): Promise<IValidatedResponse<IGetMeResponse>> {
  return getRequest<IGetMeResponse>({
    path: '/account/me',
    schema: getMeResponseSchema,
  });
}
